import {
  canFilterMuaHoOrders,
  isMuaHoOnlyOrderViewer,
  MUA_HO_ORDER_FILTER_SUPPORT_VALUE,
} from './customerCreatePermission';

const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj || {}, key);

/** Input ẩn của lọc cột và ô keyword. Không gồm dateFrom/dateTo hay nhãn dateRange. */
const COLUMN_FILTER_KEYS = [
  'keyword',
  'dates',
  'lines',
  'sackCodes',
  'chinaCodes',
  'vietnamCodes',
  'productNames',
  'status',
  'customers',
  'rateStatus',
  'contacts',
  'contactRateStatus',
  'deletion',
  'draft',
  'outdate',
  'support',
  'overdue',
];

export function nextExpressFilterValue(current, value) {
  return String(current ?? '') === String(value) ? '' : value;
}

function isDateRangeChipCleared(session, formData) {
  const sessionHasDate = Boolean(session?.dateFrom || session?.dateTo);
  if (!sessionHasDate) return false;
  if (!hasOwn(formData, 'dateRange')) return false;
  return String(formData.dateRange ?? '').trim() === '';
}

/**
 * Ghép tham số tìm đơn admin.
 * Session là gốc. Form chỉ ghi đè keyword và lọc cột.
 * dateFrom/dateTo đổi khi filter mang hai key đó, hoặc chip dateRange vừa bị xóa.
 */
export function buildOrderAdminSearchParams({
  session = {},
  formData = {},
  filter,
  isFirstSearch = false,
  orderScreenPerm,
} = {}) {
  const params = { ...(session || {}) };

  if (!isFirstSearch) {
    for (const key of COLUMN_FILTER_KEYS) {
      if (hasOwn(formData, key)) {
        params[key] = formData[key];
      }
    }
  }

  if (filter) Object.assign(params, filter);

  const filterSetsDate = hasOwn(filter, 'dateFrom') || hasOwn(filter, 'dateTo');
  if (filterSetsDate) {
    if (!params.dateFrom && !params.dateTo) {
      delete params.dateFrom;
      delete params.dateTo;
    }
  } else if (!isFirstSearch && isDateRangeChipCleared(session, formData)) {
    delete params.dateFrom;
    delete params.dateTo;
  }

  delete params.dateRange;

  if (orderScreenPerm?.loaded && isMuaHoOnlyOrderViewer(orderScreenPerm)) {
    params.support = MUA_HO_ORDER_FILTER_SUPPORT_VALUE;
  } else if (orderScreenPerm?.loaded && !canFilterMuaHoOrders(orderScreenPerm)) {
    delete params.support;
  }

  return params;
}
